<template>
    <div>    
        <div class="container-fluid" id="dvcrud">
            <div class="row">
                <div class="col-md-12">
                    <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
                </div>
                <div class="col-md-12">
                    <div id="pnlista" class="card" style="display: none;">
                        <div class="card-header"><span id="titlista">PAINEL DE {{ itensbc.item1.titulo }}</span>
                            <router-link to="/">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> 
                            </router-link>
                        </div>
                        <div class="card-body" style="padding: 10px;">
                            <div class="row">
                                <div class="col-sm-4 col-md-2 col-lg-2">
                                    <label for="cbopfiltro">Filtrar:</label>
                                    <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                        <option value="0">Código</option>
                                        <option value="1">Nome cliente</option>
                                        <option value="2">ID cliente</option>
                                    </select>
                                </div>
                                <div class="col-sm-8 col-md-6 col-lg-6">
                                    <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                    <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                                </div>
                                <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                    <label for="cbqtdreg">Itens exibidos:</label>
                                    <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                        <option value="40">40</option>
                                        <option value="50">50</option>
                                        <option value="99999999999">Todos</option>
                                    </select>
                                </div>
                                <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                    <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Consultar</button>
                                </div>
                                <div class="col-md-12" style="margin-top: 10px;">
                                    <vue-bootstrap4-table
                                            :rows="lstrenegociacoes"
                                            :columns="columns"
                                            :config="config"
                                            :classes="classes">
                                        <template slot="empty-results">
                                            <div class="col-md-12 text-center">Sem dados para visualização</div>
                                        </template>
                                        <!-- ícones de ordenação da table -->
                                        <template slot="sort-asc-icon">
                                            <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                        </template>
                                        <template slot="sort-desc-icon">
                                            <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                        </template>
                                        <template slot="no-sort-icon">
                                            <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                        </template>                                    
                                        <!--  -->                                    
                                        <template slot="id_f" slot-scope="item">
                                            {{ item.row.id }}
                                        </template>
                                        <template slot="slot_nomecliente" slot-scope="item">
                                                    {{ mtdformatarzeros(item.row.idcliente, 8) }} - {{ item.row.nomecliente }}
                                        </template>
                                        <template slot="slot_situacao" slot-scope="item">
                                            <span v-if="parseInt(item.row.situacao) === 0"      class="badge badge-pill badge-primary bdg-aberto" style="">Aberto</span>
                                            <span v-else-if="parseInt(item.row.situacao) === 1" class="badge badge-pill badge-primary bdg-efetivado">Efetivado</span>
                                            <span v-else-if="parseInt(item.row.situacao) === 3" class="badge badge-pill badge-primary bdg-extornado">Extornado</span>
                                        </template>                                                                      
                                        <template slot="opcoes" slot-scope="item">
                                            <!-- <button type="button" class="btn btn-info    btn-sm btn-opcrud btn-alterar ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                            <button type="button" class="btn btn-danger  btn-sm btn-opcrud btn-excluir ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                            <button v-if="parseInt(item.row.situacao) === 0" type="button" class="btn btn-primary btn-sm btn-opcrud btn-evetivar ajt-btn" @click.prevent="mtdefetivar(item.row)"><i class="fa fa-bolt"></i></button>
                                            <button v-else-if="parseInt(item.row.situacao) === 1" type="button" class="btn btn-primary btn-sm btn-opcrud btn-extornar ajt-btn" @click.prevent="mtdextornar(item.row)"><i class="fa fa-exchange"></i></button>
                                            <button type="button" class="btn btn-info    btn-sm btn-opcrud btn-imprimir ajt-btn" @click.prevent="mtdimprimir(item.row.id, item.row.situacao)"><i class="fa fa-print"></i></button> -->
                                            <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
                                                <i class="fa fa-navicon"></i>
                                            </button>  
                                        </template>
                                    </vue-bootstrap4-table>
                                </div>
                                <div class="col-md-12">
                                    <ul class="list-group">
                                        <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                            Itens exibidos
                                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstrenegociacoes.length}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer" style="padding: 10px;">
                            <div class="row">
                                <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                    <v-pagination
                                            v-model="pagina_atual"
                                            :page-count="pqtd_paginas"
                                            :classes="bootstrapPaginationClasses">
                                    </v-pagination>
                                </div>
                                <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                    <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Criar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="pncadastro" class="card" style="display:none;">
                        <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active" data-toggle="tab" href="#dvtitulos">Títulos à renegociar</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" data-toggle="tab" href="#dvobservacoes">Anotações</a>
                                        </li>									
                                        <li class="nav-item">
                                            <a class="nav-link" data-toggle="tab" @click.prevent="mtddeform()" href="#dvrenegociacao">Renegociação</a>
                                        </li>																											
                                    </ul>
                                    <div class="tab-content border-left border-right border-bottom">
                                        <div id="dvtitulos" class="container-fluid tab-pane active" style="padding-top: 15px;">
                                            <div class="row" style="margin-bottom: 15px;">
                                                <div class="col-sm-12 col-md-4 col-lg-4">
                                                    <span class="lblselect2">Filial:</span>
                                                    <select id="cbfilial" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                        style="width:100%;"  v-bind:disabled="opcrud==3" v-model="pidfilial">
                                                    </select>
                                                </div>                            
                                                <div class="col-sm-12 col-md-4 col-lg-4">
                                                    <span class="lblselect2">Parceiro cliente:</span>
                                                    <select id="cbcliente" data-placeholder="Selecione um cliente" data-allow-clear="true"
                                                        style="width:100%;"  v-bind:disabled="opcrud>1" v-model="pidcliente">
                                                    </select>
                                                </div>
                                                <div class="col-sm-12 col-md-4 col-lg-4">
                                                    <span class="lblselect2">Vendedor:</span>
                                                    <select id="cbvendedor" data-placeholder="Selecione um vendedor" v-bind:disabled="opcrud==3" data-allow-clear="true"
                                                        v-model="pidvendedor" style="width:100%;">
                                                    </select>
                                                </div>                            
                                                <div class="col-sm-12 col-md-2 col-lg-2">
                                                    <label for="cbfiltroperiodo">Período:</label>
                                                    <select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem_titulos()">
                                                        <option value="0">Não</option>
                                                        <option value="1">Sim</option>
                                                    </select>
                                                </div>                           
                                                <div class="col-sm-12 col-md-2 col-lg-2">
                                                    <label for="eddtini">De:</label>
                                                    <div class="input-group">
                                                        <date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem_titulos()"></date-picker>
                                                        <div class="input-group-append">
                                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                                        </div>								
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-2 col-lg-2">
                                                    <label for="eddtfim">até:</label>
                                                    <div class="input-group">
                                                        <date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem_titulos()"></date-picker>
                                                        <div class="input-group-append">
                                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                                        </div>																			
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-2 col-lg-2">
                                                    <label for="cbfiltropor">Por:</label>
                                                    <select class="form-control form-control-sm" id="cbfiltropor" v-bind:disabled="opcrud==3" v-model="ppor" @change="mtdlimpar_listagem_titulos()">
                                                        <option value="0">Data Vencimento</option>
                                                        <option value="1">Data Emissão</option>
                                                    </select>
                                                </div>                            
                                                <div class="col-sm-12 col-md-2 col-lg-2 col-md-offset-2 col-lg-offset-2">
                                                    <label for="cbordem">Ordem:</label>
                                                    <select name="cbqtdreg" class="form-control form-control-sm" id="cbordem" v-bind:disabled="opcrud==3" v-model="pordem" @change="mtdlimpar_listagem_titulos()">
                                                        <option value="0">Emissão</option>
                                                        <option value="1">Vencimento</option>
                                                    </select>
                                                </div>
                                                <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                                    <button type="button" id="btlistar" v-bind:disabled="opcrud==3" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisatitulos()"><i class="fa fa-search"></i> Consultar</button>
                                                </div>
                                            </div>
                                            
                                            <vue-bootstrap4-table v-bind:disabled="opcrud==3" ref="reflsttitulos" 
                                                @on-select-row="mtdcalculaselecionados()"
                                                @on-unselect-row="mtdcalculaselecionados()"
                                                @on-all-select-rows="mtdcalculaselecionados()"
                                                @on-all-unselect-rows="mtdcalculaselecionados()"
                                                    :rows="lsttitulos"
                                                    :columns="columnstitulos"
                                                    :config="configtitulos"
                                                    :classes="classes">
                                                <template slot="empty-results">
                                                    <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                </template>
                                                <template slot="sort-asc-icon">
                                                    <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                </template>
                                                <template slot="sort-desc-icon">
                                                    <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                </template>
                                                <template slot="no-sort-icon">
                                                    <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                </template>                                    
                                                <template slot="slot_nomecliente" slot-scope="item">
                                                    {{ mtdformatarzeros(item.row.idcliente, 8) }} - {{ item.row.nomecliente }}
                                                </template>                                           
                                                <template slot="slot_vltit" slot-scope="item">
                                                    <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vltit), 2) }}</span>
                                                </template>
                                                <template slot="slot_vlresta" slot-scope="item">
                                                    <span style="color: #6c757d; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlresta), 2) }}</span>
                                                </template>                                     
                                                <template slot="slot_atraso" slot-scope="item">
                                                    <span v-if="parseInt(item.row.atraso) > 0" class="badge badge-pill badge-danger">{{ item.row.atraso }}</span>
                                                    <span v-else></span>
                                                </template>
                                                <template slot="slot_vljuros" slot-scope="item">
                                                    <span>{{ mtdformatavalordecimal(parseFloat(item.row.vljuros), 2) }}</span>
                                                </template>
                                                <template slot="slot_vlmulta" slot-scope="item">
                                                    <span>{{ mtdformatavalordecimal(parseFloat(item.row.vlmulta), 2) }}</span>
                                                </template>                                    
                                                <template slot="slot_vlapagar" slot-scope="item">
                                                    <span style="color: #5A956A; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlapagar), 2) }}</span>
                                                </template>                                                                         
                                            </vue-bootstrap4-table>
    
                                            <div class="row justify-content-center" style="margin-bottom: 15px;">
                                                <div class="col-sm-12 col-md-6 col-lg-6">
                                                    <ul class="list-group">
                                                        <a class="list-group-item lstdetrec"><span class="badge badge-primary">Total Previsto</span></a>
                                                        <a class="list-group-item lstdetrec">Vencidos <span class="badge badge-danger bdgtitulos">{{ mtdformatavalordecimal(vVencidos, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">A vencer <span class="badge badge-primary bdgtitulos">{{ mtdformatavalordecimal(vAvencer, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Juros <span class="badge badge-warning bdgtitulos">{{ mtdformatavalordecimal(vJuros, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vMulta, 2) }}</span></a>                                                    
                                                        <a class="list-group-item lstdetrec">Qtd. Parcelas <span class="badge badge-info bdgtitulos" style="font-size: 12px;">{{ lsttitulos.length }}</span></a>
                                                    </ul>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-lg-6" id="dvselecionados">
                                                    <ul class="list-group">
                                                        <a class="list-group-item lstdetrec"><span class="badge badge-primary">Total à negociar</span></a>
                                                        <a class="list-group-item lstdetrec">A negociar <span class="badge badge-primary bdgtitulos">{{ mtdformatavalordecimal(vlapagarreneg, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Juros <span class="badge badge-warning bdgtitulos">{{ mtdformatavalordecimal(vltotjurosreneg, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vltotmultasreneg, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Total <span class="badge badge-success bdgtitulos">{{ mtdformatavalordecimal( vTotalRenegSel , 2) }}</span></a>                                                    
                                                        <a class="list-group-item lstdetrec">Selecionados <span class="badge badge-info bdgtitulos">{{ vselecionados }}</span></a>                                                                
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
    
                                        <div id="dvobservacoes" class="container-fluid tab-pane" style="padding-top: 15px; padding-bottom: 15px;">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <textarea class="form-control center" rows="10" id="txtobservacoes" style="text-transform: uppercase;" v-bind:disabled="opcrud==3" v-model="vobservacoes"></textarea>
                                                </div>											
                                            </div>
                                        </div>
    
                                        <div id="dvrenegociacao" class="container-fluid tab-pane" style="padding-top: 15px;">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-4 col-lg-4">
                                                    <span class="lblselect2">*Tipo de cobrança:</span>
                                                    <select id="cbtipocobranca" v-model="vidtipocobranca"  v-bind:disabled="opcrud==3"
                                                            data-placeholder="Selecione tipo de cobrança" data-allow-clear="true"
                                                            style="width:100%;">
                                                    </select>
                                                </div>
                                                <div class="col-sm-12 col-md-4 col-lg-4">
                                                    <span class="lblselect2">*Cobrador:</span>
                                                    <select id="cbcobrador" v-model="vidcobrador"      v-bind:disabled="opcrud==3"
                                                            data-placeholder="Selecione um cobrador" data-allow-clear="true"
                                                            style="width:100%;">
                                                    </select>
                                                </div>
                                                <div class="col-sm-12 col-md-4 col-lg-4">
                                                    <span class="lblselect2">*Vendedor:</span>
                                                    <select id="cbvendedorreneg" v-model="vidvendedor"  v-bind:disabled="opcrud==3"
                                                            data-placeholder="Selecione um vendedor" data-allow-clear="true"
                                                            style="width:100%;">
                                                    </select>
                                                </div>
                                            </div>
    
                                            <div class="row">
                                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                                    <label for="edpercdescjuros">Desconto Juros %:</label>
                                                    <money type="text" class="form-control form-control-sm input-money" id="edpercdescjuros"
                                                        v-model="vpercdescjuros"  v-bind="money" @blur.native="mtdliberacalc('vpercdescjuros')" v-bind:disabled="opcrud==3"
                                                        data-bv-group=".group" style="text-align:right; font-weight: bold;">
                                                    </money>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                                    <label for="edvldescjuros">Valor Juros:</label>
                                                    <money type="text" class="form-control form-control-sm input-money" id="edvldescjuros"
                                                        v-model="vvalordescjuros" @blur.native="mtdliberacalc('vvalordescjuros')" v-bind="money" v-bind:class="addJurosClass"   v-bind:disabled="opcrud==3"
                                                        data-bv-group=".group" style="text-align:right; font-weight: bold;">
                                                    </money>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                                    <label for="edpercdescmulta">Desconto Multa %:</label>
                                                    <money type="text" class="form-control form-control-sm input-money" id="edpercdescmulta"
                                                        v-model="vpercdescmulta" @blur.native="mtdliberacalc('vpercdescmulta')" v-bind="money"  v-bind:disabled="opcrud==3"
                                                        data-bv-group=".group" style="text-align:right; font-weight: bold;">
                                                    </money>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                                    <label for="edvldescmulta">Valor  Multa:</label>
                                                    <money type="text" class="form-control form-control-sm input-money" id="edvldescmulta"
                                                        v-model="vvalordescmulta" @blur.native="mtdliberacalc('vvalordescmulta')" v-bind="money" v-bind:class="addMultaClass"  v-bind:disabled="opcrud==3"
                                                        data-bv-group=".group" style="text-align:right; font-weight: bold;">
                                                    </money>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                                    <label for="edvlnegociar">Total à negociar:</label>
                                                    <money type="text" class="form-control form-control-sm input-money" id="edvlnegociar"
                                                        v-model="vtotalnegociar" v-bind="money" disabled
                                                        data-bv-group=".group" style="text-align:right; font-weight: bold;">
                                                    </money>
                                                </div>
                                                <div class="col-sm-12 col-md-2 col-lg-2">
                                                    <label for="eddtpriparc">Data 1ª Parcela:</label>
                                                    <div class="input-group">
                                                        <date-picker id="eddtpriparc" v-model="vdtpriparc" :config="options"   v-bind:disabled="opcrud==3"
                                                            class="form-control form-control-sm" style="font-weight: bold;"></date-picker>
                                                        <div class="input-group-append">
                                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                                        </div>																			
                                                    </div>
                                                </div>
                                            </div>
    
                                            <div class="row">
                                                <div class="col-sm-12 col-md-4 col-lg-2">
                                                    <label for="cbtpdesc">Atribuir:</label>
                                                    <select class="form-control form-control-sm" id="cbtpdesc" 
                                                        v-model="vtpdescacres" v-bind="selecionadesconto"   v-bind:disabled="opcrud==3"
                                                        style="font-weight: bold;">
                                                        <option value="0"></option>
                                                        <option value="1">Desconto</option>
                                                        <option value="2">Acréscimo</option>
                                                    </select>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                                    <label for="edvlacrescimo">Valor Desc/Acrésc:</label>
                                                    <money type="text" class="form-control form-control-sm input-money" id="edvlacrescimo"
                                                        v-model="vvalordescacres" @blur.native="mtdliberacalc('vvalordescacres')" v-bind="money"   
                                                        data-bv-group=".group" style="text-align:right; font-weight: bold;" v-bind:disabled="hab_desab_desconto">
                                                    </money>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                                    <label for="edtotapagar">Total:</label>
                                                    <money type="text" class="form-control form-control-sm input-money" id="edtotapagar"
                                                        v-model="vtotalpagar" v-bind="money" disabled
                                                        data-bv-group=".group" style="text-align:right; font-weight: bold;">
                                                    </money>
                                                </div>
                                                <div class="col-sm-12 col-md-4 col-lg-2">
                                                    <label for="cbdefentrada">Definir Entrada:</label>
                                                    <select class="form-control form-control-sm" id="cbdefentrada" v-model="vdefentrada" 
                                                        style="font-weight: bold;" v-bind="selecionaentrada"  v-bind:disabled="opcrud==3">
                                                        <option value="0">Não</option>
                                                        <option value="1">Sim</option>
                                                    </select>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                                    <label for="edvlentrada">Valor de Entrada:</label>
                                                    <money type="text" class="form-control form-control-sm input-money" id="edvlentrada"
                                                        v-model="vvalorlentrada" v-bind="money"
                                                        data-bv-group=".group" style="text-align:right; font-weight: bold;" v-bind:disabled="vdefentrada==0">
                                                    </money>
                                                </div>
                                                <div class="col-sm-12 col-md-2 col-lg-2">
                                                    <label for="edqtdparc">Qtd. Parcelas:</label>
                                                    <input type="number" class="form-control form-control-sm" id="edqtdparc" 
                                                    style="text-align: center; font-weight: bold;"
                                                    v-model="vqtdparc" data-bv-group=".group" maxlength="11" min="1" max="100"  v-bind:disabled="opcrud==3">
                                                </div>
                                            </div>
    
                                            <div class="row" style="margin-bottom: 15px;">
                                                <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                                    <label for="cbdefentrada">Personalizar juros e multa:</label>
                                                    <select class="form-control form-control-sm" id="cbdefnewj" v-model="vdefnovoj" 
                                                        style="font-weight: bold;" v-bind="selecionanovosjm">
                                                        <option value="0">Não</option>
                                                        <option value="1">Sim</option>
                                                    </select>
                                                </div>
                                                <div v-if="(hab_desab_novo_juros_multa==false)" class="col-sm-12 col-md-12 col-lg-8">
                                                    
                                                </div>
                                                <div v-else style="margin-bottom: 15px;" class="row">
                                                        <div class="col-sm-12 col-md-4 col-lg-3">
                                                        <label for="cbdefentrada">Tipo de juros:</label>
                                                        <select class="form-control form-control-sm" id="cbdefnewj" v-model="vtpjurosnew" 
                                                            style="font-weight: bold;"   v-bind:disabled="opcrud==3" >
                                                            <option value="0">Persentual (%)</option>
                                                            <option value="1">Em valor (R$)</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3">
                                                        <label for="edvlentrada">Fator de juros:</label>
                                                        <money type="text" class="form-control form-control-sm input-money" id="edvlentrada"
                                                            v-model="vfatorjurosnew" v-bind="money"  v-bind:disabled="opcrud==3"
                                                            data-bv-group=".group" style="text-align:right; font-weight: bold;" >
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-4 col-lg-3">
                                                        <label for="cbdefentrada">Tipo de multa:</label>
                                                        <select class="form-control form-control-sm" id="cbdefnewm" v-model="vtpmultanew" 
                                                            style="font-weight: bold;"  v-bind:disabled="opcrud==3">
                                                            <option value="0">Persentual (%)</option>
                                                            <option value="1">Em valor (R$)</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3">
                                                        <label for="edvlentrada">Fator de multa:</label>
                                                        <money type="text" class="form-control form-control-sm input-money" id="edvlentrada"
                                                            v-model="vfatormultanew" v-bind="money"   v-bind:disabled="opcrud==3"
                                                            data-bv-group=".group" style="text-align:right; font-weight: bold;" >
                                                        </money>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-2 col-lg-2">
                                                    <label for="edintervalo">Intervalo:</label>
                                                    <input type="number" class="form-control form-control-sm" id="edintervalo" 
                                                    style="text-align: center; font-weight: bold;"   v-bind:disabled="opcrud==3"
                                                    v-model="vIntervalo" data-bv-group=".group" maxlength="11" min="1" max="99999">
                                                </div>                                            
                                            </div>
    
                                             <div class="row" style="margin-bottom: 15px;">
                                                <div class="col-sm-12 col-md-4 col-lg-4">
                                                    <label for="edmotivoreneg">Motivo da renegociação:</label>
                                                    <input type="text" class="form-control form-control-sm" id="edmotivoreneg" 
                                                    style="text-transform: uppercase; font-weight: bold;"   v-bind:disabled="opcrud==3"
                                                    v-model="vmotivoreneg" data-bv-group=".group" maxlength="100">
                                                </div>
                                                <div class="col-sm-12 col-md-4 col-lg-4">
                                                    <label for="edobsTit">Observação dos Títulos:</label>
                                                    <input type="text" class="form-control form-control-sm" id="edobsTit" 
                                                    style="text-transform: uppercase; font-weight: bold;"  v-bind:disabled="opcrud==3"
                                                    v-model="vobsreneg" data-bv-group=".group" maxlength="50">
                                                </div>
                                                <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 15px;">
                                                    <div class="custom-control custom-switch" >
                                                        <input type="checkbox" class="custom-control-input" id="cbentradadir" v-model="vsubtrairentrada"  v-bind:disabled="opcrud==3">
                                                        <label class="custom-control-label" for="cbentradadir" id="cbentradadir" >Subtrair entrada</label>
                                                    </div>
                                                </div>
                                                <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                                    <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" 
                                                        @click.prevent="mtdgerarparcelas()" v-bind:disabled="validou"><i class="fa fa-check"></i> Gerar</button>
                                                </div>                                            
                                            </div>
    
                                            <vue-bootstrap4-table   v-bind:disabled="opcrud==3"
                                                    :rows="lsttitulosgp"
                                                    :columns="columnstitulosreneg"
                                                    :config="configreneg"
                                                    :classes="classes">
                                                <template slot="empty-results">
                                                    <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                </template>
                                                <template slot="sort-asc-icon">
                                                    <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                </template>
                                                <template slot="sort-desc-icon">
                                                    <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                </template>
                                                <template slot="no-sort-icon">
                                                    <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                </template>
                                                <template slot="opcoes" slot-scope="item">
                                                    <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterartitulo(item.row)" title="Editar"><i class="fa fa-edit"></i></button>
                                                </template>
                                                <template slot="slot_vltit" slot-scope="item">
                                                    <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vltit), 2) }}</span>
                                                </template>
                                            </vue-bootstrap4-table>
    
                                            <div class="col-md-12" style="padding-left: 0px; padding-right: 0px; margin-bottom: 15px;">
                                                <ul class="list-group">
                                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                                        <span style="color: #666666; font-weight: bold;">Soma do títulos</span>
                                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #727cf5;">{{mtdformatavalordecimal(parseFloat(tottitlista), 2)}}</span>
                                                    </li>
                                                </ul>
                                            </div>
    
                                            <div class="row">
                                                <div class="col-sm-8">
                                                    <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos obrigatórios são sinalizados com \*</strong>.</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                            
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-sm-8">
                                    <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos obrigatórios são sinalizados com \*</strong>.</h5>
                                </div>
                                <div class="col-sm-2">
                                    <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                            v-bind:disabled="validoucrud" class="btn btn-primary btn-sm"
                                            style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Salvar
                                    </button>
                                    <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                            v-bind:disabled="validoucrud" class="btn btn-primary btn-sm"
                                            style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Editar
                                    </button>
                                    <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                            v-bind:disabled="validoucrud" class="btn btn-primary btn-sm"
                                            style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Remover
                                    </button>
                                </div>
                                <div class="col-sm-2">
                                    <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                        <i class="fa fa-close"></i> Fechar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                
                       <!-- Modal para alteração da parcela -->
                    <div class="modal fade" id="mdalterartitulogp">
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                <h4 class="modal-title"><i class="fa fa-edit"></i> Alteração do título</h4>
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-4">
                                        <label>Nr. título:</label>
                                        <input type="text" class="form-control form-control-sm" v-model="tacodtitgp" disabled style="font-weight: bold;">
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <label for="eddtventitgp">Data Vencimento:</label>
                                        <div class="input-group">
                                            <date-picker id="eddtventitgp" v-model="tadtventitgp" :config="options" class="form-control form-control-sm"></date-picker>
                                            <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <label for="edvltitgp">Valor:</label>
                                        <money type="text" class="form-control form-control-sm" id="edvltitgp" v-model="tavltitgp" v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
                                    </div>
                                    <div  class="col-sm-12 col-md-12 col-lg-12">
                                        <span class="lblselect2">Tipo de cobrança:</span>
                                        <select id="cbtipocobrancaaltgp" data-placeholder="Selecione um tipo de cobrança" v-model="taidtipocobrancagp" data-allow-clear="true" style="width:100%;">
                                        </select>
                                    </div>
                                    <div v-show="parseInt(tatipocobrancagp) === 1" class="col-sm-12 col-md-12 col-lg-12" style="padding-top: 15px;">
                                        <div class="card">
                                            <div class="card-header card-in text-center" style="padding: 5px;">DADOS DO CHEQUE</div>
                                            <div class="card-body" style="padding: 10px;">
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <label>Nr. Cheque:</label>
                                                    <input type="text" id="ednumerochequegp" class="form-control form-control-sm" v-model="tanumerochequegp">
                                                </div>
                                                <div  class="col-sm-12 col-md-8 col-lg-8">
                                                    <span class="lblselect2">Banco:</span>
                                                    <select id="cbbancogp" data-placeholder="Selecione um banco" v-model="taidbancogp" data-allow-clear="true" style="width:100%;">
                                                    </select>
                                                </div>
                                                <div class="col-md-4">
                                                    <label>Agência:</label>
                                                    <input type="text" id="edagenciagp" class="form-control form-control-sm" v-model="taagenciagp">
                                                </div>
                                                <div class="col-md-4">
                                                    <label>Conta:</label>
                                                    <input type="text" id="edcontagp" class="form-control form-control-sm" v-model="tacontagp">
                                                </div>
                                                <div class="col-md-4">
                                                    <label>Praça:</label>
                                                    <input type="text" id="edpracagp" class="form-control form-control-sm" v-model="tapracagp">
                                                </div>
                                                <div class="col-md-12">
                                                    <label>Emitente:</label>
                                                    <input type="text" id="edemitentegp" class="form-control form-control-sm" v-model="taemitentegp">
                                                </div>
                                                <div class="col-md-5">
                                                    <label for="edcnpjcpfgp">CNPJ/CPF:</label>
                                                    <input type="text" v-model="tacnpjcpfgp"
                                                        class="form-control form-control-sm" id="edcnpjcpfgp" 
                                                        v-mask="['###.###.###-##', '##.###.###/####-##']">
                                                </div>
                                                <div  class="col-md-7">
                                                    <span class="lblselect2">Situação do cheque:</span>
                                                    <select id="cbsituacaochequegp" data-placeholder="Selecione uma situação" v-model="taidsituacaochequegp" data-allow-clear="true" style="width:100%;">
                                                    </select>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                <div class="modal-footer" style="padding: 5px;">
                                <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtconfirmaralteracaotitulo()"><i class="fa fa-check"></i> Confirmar</button>
                                <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                      <!-- modal para extornar enegociação -->
                      <div class="modal fade" id="mdextornareneg">
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                <h4 class="modal-title"><i class="fa fa-edit"></i> Extornando a Negociação</h4>
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div  class="col-sm-12 col-md-12 col-lg-12">
                                            <span class="lblselect2">Selecione o cliente:</span>
                                            <select id="cbclienteextorno" data-placeholder="Selecione um cliente" v-model="taidtipocobrancagp" data-allow-clear="true" style="width:100%;">
                                            </select>
                                        </div>
                                        <div  class="col-sm-12 col-md-12 col-lg-12">
                                            <div class="card">
                                                <div class="card-header card-in text-center" style="padding: 5px;">RENEGOCIAÇÕES</div>
                                                <div class="row">
                                                    <table class="table table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Cod.</th>
                                                                <th scope="col">Data/hora</th>
                                                                <th scope="col">Qtd titulos</th>
                                                            
                                                            </tr>
                                                        </thead>
                                                        <tbody  style="padding: 15px;">
                                                            <tr v-for="reneg in listarenegextorno" style="cursor: pointer; padding: 15px;">
                                                                <td>{{ reneg.id }}</td>
                                                                <td>{{ reneg.dtemissao }}</td>
                                                                <td>{{ reneg.qtdparcelas }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer" style="padding: 5px;">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           <!-- modal opçoes renegociação -->
            <div class="modal fade" id="mdmenurenegociacao" tabindex="-1">
                <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <ul class="list-group" style="cursor: pointer;">
                                    <li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ mtdformatarzeros(vmenu.id, 8) }}</li>
                                    <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdalterar(vmenu)" data-dismiss="modal"><i class="fa fa-edit"></i> EDITAR</li>
                                    <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdexcluir(vmenu)" data-dismiss="modal"><i class="fa fa-trash"></i> REMOVER</li>
                                    <li v-if="parseInt(vmenu.situacao) === 0"  class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdefetivar(vmenu)" data-dismiss="modal"><i class="fa fa-bolt"></i> EFETIVAR</li>
                                    <li v-else-if="parseInt(vmenu.situacao) === 1" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdextornar(vmenu)" data-dismiss="modal"><i class="fa fa-exchange"></i> EXTORNAR</li>
                                    <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdimprimir(vmenu.id, vmenu.situacao)" data-dismiss="modal"><i class="fa fa-print"></i> IMPRIMIR</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer" style="padding: 5px;">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12 text-center">
                                    <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Fechar</button>
                                </div>
                            </div>					
                        </div>
                    </div>				        
                </div>
                </div>
            </div>
        </div>
    </div>    
    </template>
    <script>
        import BreadCrumb from '../components/cmpbreadcrumb.vue'
        import VueBootstrap4Table from 'vue-bootstrap4-table'
        import vPagination from 'vue-plain-pagination'
        import util from '../utilitarios/util.js'
        import geraparcelas from '../components/cmpgerarparcelas.vue'
    
        export default {
            name: 'cadrenegociacoes',
            components:{
                VueBootstrap4Table,
                vPagination,
                geraparcelas,
                'breadcrumb' : BreadCrumb
            },
            data: function() {
                return {
                    utodasfiliais 	       : this.$store.state.usuario.todasfiliais,
                    lstrenegociacoes       : [],
                    lsttitulos             : [],
                    detreneg               : [],
                    lsttitulosreneg        : [],                
                    pfiltro                : 1,
                    pconteudo              : '',
                    pqtdregistros          : 10,
                    pqtd_paginas           : 1,
                    pagina_atual           : 1,
                    pqtd_total_registros   : 0,
    
                    //
                    listarenegextorno      : [],
    
                    //menu
                    vmenu                  : [],
    
                    //variáveis do crud
                    opcrud                 :  0,
                    vliberacalccrud        : false,
                    vid                    : '',
                    vobservacoes		   : '',
                    pidfilial              : null,
                    pidcliente             : null,
                    pidvendedor            : null,
                    pfiltroperiodo         : 1,
                    pdtini       	 	   : util.DataAtual(true),
                    pdtfim       		   : util.DataAtual(true),
                    ppor                   : 0,
                    pordem                 : 0,
                    hab_desab_periodo      : false,
                    hab_desab_desconto     : false,
                    hab_desab_entrada      : false,
                    hab_desab_novamulta    : false,
                    hab_desab_novo_juros_multa    : false,
                    ptipocobranca          : 0,
                    vpercdescjuros         : 0,
                    vvalordescjuros        : 0,
                    vpercdescmulta         : 0,
                    vvalordescmulta        : 0,
                    vtotalnegociar         : 0,
                    vtpdescacres           : 0,
                    vvalordescacres        : 0,
                    vtotalpagar            : 0,
                    vqtdparc               : 1,
                    vIntervalo             : 30,
                    vidtipocobranca        : null,
                    vidvendedor            : null,
                    vidcobrador            : null,
                    vdtpriparc             : util.DataAtual(true),
                    vdefentrada            : 0,
                    vvalorlentrada         : 0,
                    vmotivoreneg           : '',
                    vobsreneg              : '',
                    vtotaltitulos          : 0,
                    vtpjurosnew            : 0,
                    vtpmultanew            : 0,
                    vfatorjurosnew         : 0,
                    vfatormultanew         : 0,
                    tottitlista            : 0,
                    vdefnovoj              : 0,
                    vsubtrairentrada       : false,  //define se a entrada abate o total ou então ela soma com a mesma  - guga
                    sringaleatoria         : '',
    
    
                    //variável para habilitação dos campos
                    ativadesativa          : true,
    
                    //Totais dos selecionados
                    vqtdtitsel             : 0,
                    vTotalRenegSel         : 0,
                    vTotalJurosSel         : 0,
                    vTotalMultaSel         : 0,
                    vTotalGeralSel         : 0,
                    vVencidos              : 0,
                    vAvencer               : 0,
                    vJuros                 : 0,
                    vMulta                 : 0,
                    vTotal                 : 0,
    
                    //selecionados by guga
                    vselecionados          :0,
                    vlapagarreneg          :0,
                    vltotjurosreneg        :0,
                    vltotmultasreneg       :0,
    
                    //variaveis auxiliares de geração de novas parcelas
                    
                    vnovojuros             : 0,
                    vnovamulta             : 0,
                    vtipocalcjuros         : 0,
                    vtipocalcmulta         : 0, 
                    lsttitulosgp           : [],               
    
                    //variáveis da alteração das parcelas
                    altcodtit 			   : '',
                    altdtventit			   : '',
                    altvltit			   : 0,
                    altidtipocobranca	   : null,
                    alttipocobranca		   : 0,
                    altdescricaocob		   : '',
                    altnumerocheque		   : '',
                    altidbanco			   : null,
                    altdescbanco		   : '',
                    altagencia			   : '',
                    altconta		   	   : '',
                    altpraca			   : '',
                    altemitente			   : '',
                    altcnpjcpf			   : '',
                    altidsituacaocheque	   : null,
                    altdescsituacaocheque  : '',
    
                    tipocobgp              : 0, //variável para determinar se é cheque ou não
    
                    addJurosClass          : '',
                    addMultaClass          : '',
    
                     //variáveis da alteração do título
    
                    tacodtitgp             : '',
                    tadtventitgp           : '',
                    tavltitgp              : 0,
                    taidtipocobrancagp     : null,
                    tatipocobrancagp       : 0, // 0 - Normal 1 - Cheque
                    tadescricaocobgp       : '',
                    tanumerochequegp       : '',
                    taidbancogp            : null,
                    tadescbancogp          : '',
                    taagenciagp            : '',
                    tacontagp              : '',
                    tapracagp              : '',
                    taemitentegp           : '',
                    tacnpjcpfgp            : '',
                    taidsituacaochequegp   : null,
                    tadescsituacaochequegp : '',
                    listou                 : 0,
    
                    //campos novas parcelass - by guga 
    
                    
    
                    novojuros              : false,
                    novamulta              : false,
    
    
                    bootstrapPaginationClasses: {
                        ul: 'pagination pagination-sm',
                        li: 'page-item',
                        liActive: 'active',
                        liDisable: 'disabled',
                        button: 'page-link'
                    },
                    itensbc : {
                        item1 : {
                            titulo : 'RENEGOCIAÇÕES',
                            ativo  : false
                        },
                        item2 : {
                            titulo : '',
                            ativo  : false
                        }
                    },
                    options: {
                        format           : 'DD/MM/YYYY',
                        useCurrent       : false,
                        locale           : 'pt-BR'
                    },				
                    money				: {
                        decimal         : ',',
                        thousands       : '.',
                        prefix          : '',
                        precision       : 2,
                        masked          : false
                    },                
                    columns: [
                        {
                            label: 'Opções',
                            name : 'opcoes',
                            row_text_alignment: "text-center",
                            column_text_alignment: "text-center",
                            row_classes: "def-col-opcoes-reneg",
                            sort: false
                        },
                        {
                            label: "Código",
                            name: "id",
                            sort: true,
                            row_classes: "def-col-cod",
                        },
                        {
                            label: "Cliente",
                            name: "cliente",
                            initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                            initial_sort_order: 'asc',
                            sort: true,
                            slot_name: "slot_nomecliente",
                            row_text_alignment: "text-left",
                            column_text_alignment: "text-left"
                        },
                        {
                            label: "Situação",
                            name: "situacao",
                            sort: true,
                            slot_name: "slot_situacao",
                            row_classes: "def-col-situacao",
                            row_text_alignment: "text-center",
                            column_text_alignment: "text-left"
                        }
                    ],
                    columnsreneg: [
                        {
                            label: 'Opções',
                            name : 'opcoes',
                            row_text_alignment: "text-center",
                            column_text_alignment: "text-center",
                            row_classes: "def-col-opcoes",
                            sort: false
                        },
                        {
                            label: "Cód.Reneg. ",
                            name: "id",
                            sort: true,
                            row_text_alignment: "text-center",
                            column_text_alignment: "text-left",                        
                            row_classes: "def-col-id"
                        },					
                        {
                            label: "Cliente",
                            name: "nomecliente",
                            initial_sort : false,
                            initial_sort_order: 'asc',
                            sort: true,
                            slot_name: "slot_nomecliente",
                            row_text_alignment: "text-left",
                            column_text_alignment: "text-left",
                            row_classes: "def-col-nomecliente",
                        },                                        
                        {
                            label: "Emissão",
                            name: "dtemissao",
                            sort: true,
                            row_text_alignment: "text-left",
                            column_text_alignment: "text-left",                        
                            row_classes: "def-col-datas"
                        },
                        {
                            label: "Qtd.Parc.",
                            name: "qtdparcelas",
                            sort: true,
                            row_text_alignment: "text-center",
                            column_text_alignment: "text-center",                        
                            row_classes: "def-col-qtdparcelas"
                        },
                        {
                            label: "Intervalo",
                            name: "intervalo",
                            sort: true,
                            row_text_alignment: "text-center",
                            column_text_alignment: "text-center",                        
                            row_classes: "def-col-intervalo"
                        },					
                        {
                            label: "Total",
                            name: "totalnegociado",
                            sort: true,
                            slot_name: "slot_totalnegociado",
                            row_text_alignment: "text-right",
                            column_text_alignment: "text-left",                        
                            row_classes: "def-col-valores"
                        },
                        {
                            label: "Situacao",
                            name: "situacao",
                            sort: true,
                            slot_name: "slot_situacao",
                            row_text_alignment: "text-center",
                            column_text_alignment: "text-center",                        
                            row_classes: "def-col-situacao"
                        }                                        
                    ],
                    configreneg: {
                        pagination: false,
                        pagination_info: false,
                        card_mode: false,
                        global_search: {
                            visibility: false,
                        },
                        show_refresh_button : false,
                        show_reset_button : false
                    },								
                    columnstitulos: [
                        {
                            label: "Nr. Título",
                            name: "codtit",
                            sort: true,
                            row_text_alignment: "text-left",
                            column_text_alignment: "text-left",                        
                            row_classes: "def-col-codtit"
                        },
                        {
                            label: "Cliente",
                            name: "nomecliente",
                            initial_sort : false,
                            initial_sort_order: 'asc',
                            sort: true,
                            slot_name: "slot_nomecliente",
                            row_text_alignment: "text-left",
                            column_text_alignment: "text-left",
                            row_classes: "def-col-nomecliente",
                        },                                       
                        {
                            label: "Emissão",
                            name: "dtemitit",
                            sort: true,
                            row_text_alignment: "text-left",
                            column_text_alignment: "text-left",                        
                            row_classes: "def-col-datas"
                        },
                        {
                            label: "Vencimento",
                            name: "dtventit",
                            sort: true,
                            row_text_alignment: "text-left",
                            column_text_alignment: "text-left",                        
                            row_classes: "def-col-datas"
                        },
                        {
                            label: "Vl. títiulo",
                            name: "vltit",
                            sort: true,
                            slot_name: "slot_vltit",
                            row_text_alignment: "text-right",
                            column_text_alignment: "text-left",                        
                            row_classes: "def-col-valores"
                        },
                        {
                            label: "Restante",
                            name: "vlresta",
                            sort: true,
                            slot_name: "slot_vlresta",
                            row_text_alignment: "text-right",
                            column_text_alignment: "text-left",                        
                            row_classes: "def-col-valores"
                        },                    
                        {
                            label: "Atraso",
                            name: "atraso",
                            sort: true,
                            slot_name: "slot_atraso",
                            row_text_alignment: "text-center",
                            column_text_alignment: "text-left",                        
                            row_classes: "def-col-valores"
                        },
                        {
                            label: "Juros",
                            name: "vljuros",
                            sort: true,
                            slot_name: "slot_vljuros",
                            row_text_alignment: "text-right",
                            column_text_alignment: "text-left",                        
                            row_classes: "def-col-valores"
                        },                                                              
                        {
                            label: "Multa",
                            name: "vlmulta",
                            sort: true,
                            slot_name: "slot_vlmulta",
                            row_text_alignment: "text-right",
                            column_text_alignment: "text-left",                        
                            row_classes: "def-col-valores"
                        },
                        { 
                            label: "À receber",
                            name: "vlapagar",
                            sort: true,
                            slot_name: "slot_vlapagar",
                            row_text_alignment: "text-right",
                            column_text_alignment: "text-left",                        
                            row_classes: "def-col-valores"
                        },                                        
                    ],
                    columnstitulosreneg: [
                        {
                            label: 'Opções',
                            name : 'opcoes',
                            row_text_alignment: "text-center",
                            column_text_alignment: "text-center",
                            row_classes: "def-col-opcoes",
                            sort: false
                        },
                        {
                            label: "Nr. Título",
                            name: "codtit",
                            sort: true,
                            row_text_alignment: "text-left",
                            column_text_alignment: "text-left",                        
                            row_classes: "def-col-codtit"
                        },                                       
                        {
                            label: "Vencimento",
                            name: "dtventit",
                            sort: true,
                            row_text_alignment: "text-left",
                            column_text_alignment: "text-left",
                            row_classes: "def-col-datas"
                        },
                        {
                            label: "Tipo de cobrança",
                            name: "descricaocob",
                            initial_sort : false,
                            initial_sort_order: 'asc',
                            sort: true,
                            slot_name: "slot_descricaocob",
                            row_text_alignment: "text-left",
                            column_text_alignment: "text-left",
                            row_classes: "def-col-descricaocob",
                        },                    
                        {
                            label: "Vl. títiulo",
                            name: "vltit",
                            sort: true,
                            slot_name: "slot_vltit",
                            row_text_alignment: "text-right",
                            column_text_alignment: "text-left",
                            row_classes: "def-col-valores"
                        },
                        {
                            label: "Agência",
                            name: "agencia",
                            sort: true,
                            row_text_alignment: "text-center",
                            column_text_alignment: "text-center",                        
                            row_classes: "def-col-agencia"
                        },
                        {
                            label: "Conta",
                            name: "conta",
                            sort: true,
                            row_text_alignment: "text-center",
                            column_text_alignment: "text-center",                        
                            row_classes: "def-col-conta"
                        },
                        {
                            label: "Nº Cheque",
                            name: "numerocheque",
                            sort: true,
                            row_text_alignment: "text-center",
                            column_text_alignment: "text-center",                        
                            row_classes: "def-col-numerocheque"
                        }                    
                    ],                				
                    configtitulos: {
                        pagination: false,
                        pagination_info: false,
                        card_mode: false,
                        checkbox_rows: true,
                        global_search: {
                            visibility: false,
                        },
                        show_refresh_button : false,
                        show_reset_button : false
                    },
                    config: {
                        pagination: false,
                        pagination_info: false,
                        card_mode: false,
                        global_search: {
                            visibility: false,
                        },
                        show_refresh_button : false,
                        show_reset_button : false
                    },
                    classes: {
                        table: "table-bordered table-striped table-sm"
                    }
                }
            },
            methods:{
                mtdmostrarmenu(reneg){				
                    this.vmenu = reneg;
                    $('#mdmenurenegociacao').modal('show');
                },
                mtdlimpar_listagem_titulos(){
                    this.$refs.reflsttitulos.unSelectAllItems();
                    this.lsttitulos       = [];
                    this.vVencidos        = 0;
                    this.vAvencer         = 0;
                    this.vJuros           = 0;
                    this.vMulta           = 0;
                    this.vTotal           = 0;                			
                },
                mtdfiltropesquisatitulos(){
                    let rfiltro = '';
                    if(this.pidfilial !== null) {                    
                        rfiltro = rfiltro + 'and t.idfilial=' + this.pidfilial;
                    }
                    if(this.pidcliente !== null) {
                        rfiltro = ' and t.idcliente=' + this.pidcliente;
                    }                                 
                    if(this.pidvendedor !== null) {                    
                        rfiltro = rfiltro + ' and t.idvendedor=' + this.pidvendedor;
                    }
                    if(parseInt(this.pfiltroperiodo) === 1){
                        let strpor = parseInt(this.ppor) === 0 ? 'dtventit' : 'dtemitit';
                        rfiltro = rfiltro + ' and t.'+strpor+' between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
                    }
                    rfiltro = rfiltro + ' and t.sttit in ("A", "P")';
                
                    return rfiltro;
                   
                },
                mtdexecutapesquisatitulos(){
                    this.$refs.reflsttitulos.unSelectAllItems();
                    this.listou = 0;
                    if(this.opcrud==2){
                       this.listou = 1;
                    }
                    if (this.pidcliente === null || this.pidcliente === undefined || this.pidcliente === '') {
                        this.$toastr.w('Cliente deve ser informado!', 'Atenção!');
                        return;
                    }                
                    if (util.verificasessao(this)){
                        var vself       = this;
                        let loader      = this.$loading.show();
                        let filtro      = vself.mtdfiltropesquisatitulos();
                        let parametros  = [
                            {parametro: 'dbcliente',     valor : vself.$store.state.usuario.dbcliente},
                            {parametro: 'op',            valor : 'listagemtitulos'},
                            {parametro: 'situacao',      valor : "0"},
                            {parametro: 'ordem',         valor : vself.pordem},
                            {parametro: 'filtro',        valor : filtro},
                            {parametro: 'limit',         valor : "99999999999"},
                            {parametro: 'offset',        valor : "0"}
                        ];
                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadrenegociacao.php');
                        retorno.then(function (response) {
                            vself.lsttitulos = response.data.lista;
    
                            vself.vVencidos  = response.data.vencidos;
                            vself.vAvencer   = response.data.avencer;
                            vself.vJuros     = response.data.totjuros;
                            vself.vMulta     = response.data.totmulta;
                            vself.vTotal     = response.data.totgeral;
    
                            loader.hide();
                        }).catch(function (response) {
                            vself.lsttitulos = [];
                            loader.hide();
                        });
                    }
                },                        
                mtdformatavalordecimal(valor, digitos){
                    return util.formatavalordecimais(valor, digitos);
                },
                mtdformatarzeros(str, length){
                    return util.formatarzeros(str, length);
                },
                mtdformatadatagravar(dtformatar){
                    let strret = dtformatar.replace(/\D/g, "");
                    return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
                },
                mtdmontacodtit(){
                    let datahora   = util.DataAtual(true, true)
                    let retHora    = datahora.substring(11, 19)
                    retHora        = retHora.replace(':', '')
                    retHora        = retHora.replace(':', '')
                    let retAno     = datahora.substring(8, 10)
                    return retHora+retAno
                }, 
                mtdselect2_def(){
                    let vself = this;
                    let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                    let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                				
    
                    //selects da consulta
                    $("#cbfilialpesq").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2sql,						
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q		: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    sqlini	: sqliniusuario,
                                    sqlfim	: sqlfimusuario,
                                    cpid	: 'codfil',
                                    cpdesc	: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.pidfilialpesq = $("#cbfilialpesq").val();
                        vself.mtdlimpar_listagem();
                    });
                    $("#cbclientepesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclientes',
                                    c1: 'id',
                                    c2: 'nome'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 1,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.pidclientepesq = $("#cbclientepesq").val();
                        vself.mtdlimpar_listagem();
                    });
                    $("#cbusuariopesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbusuarios',
                                    c1: 'codusu',
                                    c2: 'nomeusu'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 1,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.pidusuariopesq = $("#cbusuariopesq").val();
                        vself.mtdlimpar_listagem();
                    });
                    $("#cbfilial").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2sql,						
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q		: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    sqlini	: sqliniusuario,
                                    sqlfim	: sqlfimusuario,
                                    cpid	: 'codfil',
                                    cpdesc	: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.pidfilial = $("#cbfilial").val();
                        vself.mtdlimpar_listagem_titulos();
                    });
                    $("#cbcliente").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclientes',
                                    c1: 'id',
                                    c2: 'nome'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 1,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.pidcliente = $("#cbcliente").val();
                        //vself.mtdlimpar_listagem_titulos();
                    });
                    $("#cbvendedor").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbvendedores',
                                    c1: 'id',
                                    c2: 'nome'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.pidvendedor = $("#cbvendedor").val();
                        vself.mtdlimpar_listagem_titulos();
                    });
                    $("#cbtipocobranca").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbtiposcobranca',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.vidtipocobranca = $("#cbtipocobranca").val();
                        if (vself.vidtipocobranca != null) {
                            let loader      = vself.$loading.show();
                            let parametros  = [
                                {parametro: 'op',           valor : 'listagem'},
                                {parametro: 'dbcliente',    valor : vself.$store.state.usuario.dbcliente},
                                {parametro: 'filtro',       valor : ' and id='+vself.vidtipocobranca},
                                {parametro: 'limit',        valor : 1},
                                {parametro: 'offset',       valor : 0},
                            ];
                            let retorno          = util.reqaxios(parametros, 'post', 'controller/rtcadtiposcobranca.php');
                            retorno.then(function (response) {
                                vself.tipocobgp = parseFloat(response.data[0].tipo); 
                                loader.hide();
                            }).catch(function (response) {
                                loader.hide();
                            });
                        } else {
                            vself.tipocobgp = 0;
                        }
                    });
                    $("#cbcobrador").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcobradores',
                                    c1: 'id',
                                    c2: 'nome'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.vidcobrador = $("#cbcobrador").val();
                    });
                    $("#cbvendedorreneg").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbvendedores',
                                    c1: 'id',
                                    c2: 'nome'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.vidvendedor = $("#cbvendedorreneg").val();
                    });
                    $("#cbtipocobrancatit").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbtiposcobranca',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.altidtipocobranca = $("#cbtipocobrancatit").val();
                        if (vself.altidtipocobranca != null) {
                            let loader      = vself.$loading.show();
                            let parametros  = [
                                {parametro: 'op',           valor : 'listagem'},
                                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                {parametro: 'filtro',       valor : ' and id='+vself.altidtipocobranca},
                                {parametro: 'limit',        valor : 1},
                                {parametro: 'offset',       valor : 0},
                            ];
                            let retorno          = util.reqaxios(parametros, 'post', 'controller/rtcadtiposcobranca.php');
                            retorno.then(function (response) {
                                vself.alttipocobranca = parseFloat(response.data[0].tipo); 
                                loader.hide();
                            }).catch(function (response) {
                                loader.hide();
                            });
                        } else {
                            vself.alttipocobranca = 0;
                        }
                    });
                    $("#cbbanco").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbbancos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.altidbanco = $("#cbbanco").val();
                    });
    
                    $("#cbsituacaocheque").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsituacoescheques',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.altidsituacaocheque = $("#cbsituacaocheque").val();
                    });
                    $("#cbtipocobrancaaltgp").select2({
                    id: function(e) {
                        return e.id
                    },
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function(params) {
                            return {
                                q: params.term,
                                idclientesac: vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtiposcobranca',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function(data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function() {
                    vself.taidtipocobrancagp = $("#cbtipocobrancaaltgp").val();
                    if (vself.taidtipocobrancagp != null) {
                        let loader = vself.$loading.show();
                        let parametros = [{
                                parametro: 'op',
                                valor: 'listagem'
                            },
                            {
                                parametro: 'idclientesac',
                                valor: vself.$store.state.filialpadrao.idcliente
                            },
                            {
                                parametro: 'filtro',
                                valor: ' and id=' + vself.taidtipocobrancagp
                            },
                            {
                                parametro: 'limit',
                                valor: 1
                            },
                            {
                                parametro: 'offset',
                                valor: 0
                            },
                        ];
                        let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadtiposcobranca.php');
                        retorno.then(function(response) {
                            vself.tatipocobrancagp = parseInt(response.data[0].tipo);
                            loader.hide();
                        }).catch(function(response) {
                            loader.hide();
                        });
                    } else { //quando limpa seleção
                        vself.tatipocobrancagp = 0;
                    }
                });
    
                $("#cbbancogp").select2({
                    id: function(e) {
                        return e.id
                    },
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function(params) {
                            return {
                                q: params.term,
                                idclientesac: vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbbancos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function(data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function() {
                    vself.taidbancogp = $("#cbbancogp").val();
                });
    
                $("#cbsituacaochequegp").select2({
                    id: function(e) {
                        return e.id
                    },
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function(params) {
                            return {
                                q: params.term,
                                idclientesac: vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbsituacoescheques',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function(data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function() {
                    vself.taidsituacaochequegp = $("#cbsituacaochequegp").val();
                });  
                $("#cbclienteextorno").select2({
                    id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclientes',
                                    c1: 'id',
                                    c2: 'nome'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.pidclienteextorno = $("#cbclienteextorno").val();
                        vself.listarrenegcliente(vself.pidclienteextorno)
                    });
                },                       
                mtdfiltropesquisa(){
                    let rfiltro = '';
                    if (parseInt(this.pfiltro) === 0){
                        rfiltro = this.pconteudo === '' ? '' : ' and r.id='+this.pconteudo;
                    } 
                    if (parseInt(this.pfiltro === 1)){
                        rfiltro = this.pconteudo === '' ? '' : ' and upper(nomecliente) like upper("'+this.pconteudo+'%")';
                    }
                    if (parseInt(this.pfiltro) === 2){
                        rfiltro = this.pconteudo === '' ? '' : ' and r.idcliente='+this.pconteudo;
                    }
                    return rfiltro;
                },
                mtdexecutapesquisa(){
                    var vself           = this;
                    let filtro          = vself.mtdfiltropesquisa();
                    this.pagina_atual   = 1;
                    let parametros      = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor  : 'qtdregistros'},
                        {parametro: 'filtro',       valor  : filtro}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadrenegociacao.php');
                    retorno.then(function (response) {
                        vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                        let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                        vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                        vself.mtdcarregarenegociacoes(1);
                    }).catch(function (response) {
                        alert('Erro ao consultar registros');
                    });
                },
                mtdcarregarenegociacoes(ipagina){
                    var vself       = this;
                    let loader      = this.$loading.show();
                    let filtro      = vself.mtdfiltropesquisa();
                    let parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : vself.pqtdregistros},
                        {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadrenegociacao.php');
                    retorno.then(function (response) {
                        vself.lstrenegociacoes = response.data;
                        loader.hide();
                    }).catch(function (response) {
                        vself.lstrenegociacoes = [];
                        loader.hide();
                    });
                },
                resetarDados() {
                  //variáveis do crud
                    this.$refs.reflsttitulos.unSelectAllItems()
                    this.vobservacoes		    = ''
                    this.pidfilial              = null
                    this.pidcliente             = null
                    this.pidvendedor            = null
                    this.pfiltroperiodo         = 1
                    this.pdtini       	 	    = util.DataAtual(true)
                    this.pdtfim       		    = util.DataAtual(true)
                    this.ppor                   = 0
                    this.pordem                 = 0
                    this.hab_desab_periodo      = false
                    this.hab_desab_desconto     = false
                    this.hab_desab_entrada      = false
                    this.hab_desab_novamulta    = false
                    this.hab_desab_novo_juros_multa    = false
                    this.ptipocobranca          = 0
                    this.vpercdescjuros         = 0
                    this.vvalordescjuros        = 0
                    this.vpercdescmulta         = 0
                    this.vvalordescmulta        = 0
                    this.vtotalnegociar         = 0
                    this.vtpdescacres           = 0
                    this.vvalordescacres        = 0
                    this.vtotalpagar            = 0
                    this.vqtdparc               = 1
                    this.vIntervalo             = 30
                    this.vidtipocobranca        = null
                    this.vidvendedor            = null
                    this.vidcobrador            = null
                    this.vdtpriparc             = util.DataAtual(true)
                    this.vdefentrada            = 0
                    this.vvalorlentrada         = 0
                    this.vmotivoreneg           = ''
                    this.vobsreneg              = ''
                    this.vtotaltitulos          = 0
                    this.vtpjurosnew            = 0
                    this.vtpmultanew            = 0
                    this.vfatorjurosnew         = 0
                    this.vfatormultanew         = 0
                    this.tottitlista            = 0
                    this.vsubtrairentrada       = false
                    this.sringaleatoria         = ''
    
                    //variável para habilitação dos campos
               
    
                    //Totais dos selecionados
                    this.vqtdtitsel             = 0
                    this.vTotalRenegSel         = 0
                    this.vTotalJurosSel         = 0
                    this.vTotalMultaSel         = 0
                    this.vTotalGeralSel         = 0
                    this.vVencidos              = 0
                    this.vAvencer               = 0
                    this.vJuros                 = 0
                    this.vMulta                 = 0
                    this.vTotal                 = 0
                    this.vdefnovoj              = 0
    
                    //selecionados by guga
                    this.vselecionados          =0
                    this.vlapagarreneg          =0
                    this.vltotjurosreneg        =0
                    this.vltotmultasreneg       =0
    
                    //variaveis auxiliares de geração de novas parcelas
                    
                    this.vnovojuros             = 0
                    this.vnovamulta             = 0
                    this.vtipocalcjuros         = 0
                    this.vtipocalcmulta         = 0
                    this.lsttitulosgp           = []              
    
                    //variáveis da alteração das parcelas
                    this.altcodtit 			    = ''
                    this.altdtventit			= ''
                    this.altvltit			    = 0
                    this.altidtipocobranca	    = null
                    this.alttipocobranca	    = 0
                    this.altdescricaocob	    = ''
                    this.altnumerocheque        = ''
                    this.altidbanco			    = null
                    this.altdescbanco		    = ''
                    this.altagencia			    = ''
                    this.altconta		   	    = ''
                    this.altpraca			    = ''
                    this.altemitente	        = ''
                    this.altcnpjcpf			    = ''
                    this.altidsituacaocheque    = null
                    this.altdescsituacaocheque  = ''
    
                   this.tipocobgp              = 0 //variável para determinar se é cheque ou não
                   this.addJurosClass          = ''
                   this.addMultaClass          = ''
    
                     //variáveis da alteração do título
    
                    this.tacodtitgp             = ''
                    this.tadtventitgp           = ''
                    this.tavltitgp              = 0
                    this.taidtipocobrancagp     = null
                    this.tatipocobrancagp       = 0 // 0 - Normal 1 - Cheque
                    this.tadescricaocobgp       = ''
                    this.tanumerochequegp       = ''
                    this.taidbancogp            = null
                    this.tadescbancogp          = ''
                    this.taagenciagp            = ''
                    this.tacontagp              = ''
                    this.tapracagp              = ''
                    this.taemitentegp           = ''
                    this.tacnpjcpfgp            = ''
                    this.taidsituacaochequegp   = null
                    this.tadescsituacaochequegp = ''
    
    
                    this.novojuros              = false
                    this.novamulta              = false
                    this.lsttitulos             = []
    
    
                    $("#cbtipocobranca").val(null).trigger('change');
                    $("#cbcobrador").val(null).trigger('change');
                    $("#cbvendedorreneg").val(null).trigger('change');
                    $("#cbcliente").val(null).trigger('change');
    
                },
                mtddefault(){
                    $('#pnlista').hide();
                    this.resetarDados();
                    $('#pncadastro').fadeIn(700);
                    
                    this.$nextTick(function () {
                        if (parseInt(this.opcrud) < 3) {
                            $('#eddescricao').focus();
                        } else {
                            $('#btgravar').focus();
                        }
                    });
                },
                mtdpreparacrud(op) {
                    let vself    = this;
                    this.mtddefault();
                    vself.opcrud = op;
                    vself.sringaleatoria = util.GerarStringAleatoria()
                    $('.nav-tabs a[href="#dvtitulos"]').tab('show');
                    
                },
                mtdnovo(){
                    if (!util.opcaousuario('030Z.035Z.010Z', this.$store.state.perfilusuario)){
                        this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                    }else {
                        this.itensbc.item2.titulo = 'INCLUSÃO DE RENEGOCIAÇÃO';
                        this.itensbc.item1.ativo = true;
                        this.itensbc.item2.ativo = true;
                        this.ativadesativa = false;
                        this.resetarDados();
                        this.mtdpreparacrud(1);
                    }
                },
                mtdcancelaredicao(){
                    this.itensbc.item1.ativo = false;
                    this.itensbc.item2.ativo = false;
                    this.resetarDados();
                    $('#pncadastro').hide();
                    $('#pnlista').fadeIn(700);
                    $('#edconteudopesq').focus();
                    setTimeout(function(){
                        util.toTop();
                    }, 200);
                },
                mtdlimpar_listagem() {
                    this.lstrenegociacoes = [];
                    this.listarenegextorno = [];
                    this.pagina_atual = 1;
                    this.filtro = '';
                    this.pqtd_total_registros = 0;
                    this.pqtd_paginas = 0;
                },
                mtdgravar(){
                    let vself = this;
                    if (parseInt(vself.opcrud) < 3) {
                        if (parseInt(vself.vtodasfiliais) === 0) {
                        }
                    }
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    vself.mtdregistro();
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $('#btgravar').focus();
                                }
                            }
                        }
                    });
                },
                mtdlocalizaregistro(id){
                    var vself       = this;
                    let loader      = vself.$loading.show();
                    let filtro      = ' and r.id='+id;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadrenegociacao.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.mtdigualarcampos(response.data[0]);
                        if (parseInt(vself.opcrud) < 3){
                            $('#eddescricao').focus();
                        }else{
                            $('#btgravar').focus();
                        }
                    }).catch(function (response) {
                        loader.hide();
                    });
                },
                mtdalterar(item){ 
                    
                    if (!util.opcaousuario('030Z.035Z.020Z', this.$store.state.perfilusuario)){
                        this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                    }else {
                        if(item.situacao == 1){
                            this.$toastr.i('Não é possivel alterar uma renegociação efetivada!', 'Informação!');
                            return
                        } 
                        if(item.situacao == 3){
                            this.$toastr.i('Não é possivel alterar uma renegociação extornada!', 'Informação!');
                            return
                        }else{
                            this.itensbc.item2.titulo = 'ALTERAÇÃO DE RENEGOCIAÇÃO';
                            this.itensbc.item1.ativo = true;
                            this.itensbc.item2.ativo = true;
                            this.ativadesativa = false;
                            this.mtdpreparacrud(2);
                            this.mtdlocalizaregistro(item.id);
                            this.vliberacalccrud = false;
                        }
                    }
                },
                mtdexcluir(item){
                    if (!util.opcaousuario('030Z.035Z.030Z', this.$store.state.perfilusuario)){
                        this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                    }else {
                        if(item.situacao == 1){
                            this.$toastr.i('Não é possivel excluir uma renegociação efetivada!', 'Informação!');
                            return
                        }else{
                            this.itensbc.item2.titulo = 'EXCLUSÃO DE RENEGOCIAÇÃO';
                            this.itensbc.item1.ativo = true;
                            this.itensbc.item2.ativo = true;
                            this.ativadesativa = true;
                            this.mtdpreparacrud(3);
                            this.mtdlocalizaregistro(item.id);
                        }
                       
                    }
                },
                mtdigualarcampos(registro){
                    this.vid                                = registro.id;
                    this.pidfilial                          = registro.idfilial;
                    this.pidcliente                         = registro.pidcliente;
                    this.vobservacoes                       = registro.observacoes;
                    this.vidtipocobranca                    = registro.idtipocobranca;
                    this.vidcobrador                        = registro.idcobrador;
                    this.vidvendedor                        = registro.idvendedor;
                    this.vpercdescjuros                     = registro.percdescjuros;
                    this.vvalordescjuros                    = registro.vldescontojuros;
                    this.vpercdescmulta                     = registro.percdescmulta;
                    this.vvalordescmulta                    = registro.vldescontojuros;
                    this.vtpdescacres                       = registro.tpdescacres;
                    this.vtotalpagar                        = registro.total;
                    this.vmotivoreneg                       = registro.motivo;
                    this.lsttitulos                         = registro.debitosnegociados;
                    this.lsttitulosgp                       = registro.debitosnegociadosatual;
                    this.vqtdparc                           = registro.qtdparcelas;
                    this.vIntervalo                         = registro.intervalo;
                    this.tottitlista                        = registro.totaldebatual;
                    this.vdefentrada                        = registro.defentrada;
                    this.vvalorlentrada                     = registro.vlentrada;
                    this.vvalordescacres                    = parseFloat(registro.vlacrescdesc);
                    this.vsubtrairentrada                   = parseInt(registro.subtrairentrada) === 1 ? true : false;
    
                    var deftipocobranca = new Option(registro.descobranca, registro.idtpcob, true, true);
                    $('#cbtipocobranca').append(deftipocobranca).trigger('change');
                    
                    var defcobrador     = new Option(registro.descobradores, registro.idcobrador, true, true);
                    $('#cbcobrador').append(defcobrador).trigger('change');
                    
                    var defvendedor     = new Option(registro.descvendedor, registro.idvendedor, true, true);
                    $('#cbvendedorreneg').append(defvendedor).trigger('change');
    
                    var defcliente      = new Option(registro.nomecliente, registro.idcliente,  true, true);
                    $('#cbcliente').append(defcliente).trigger('change');
                    
                    setTimeout(() => {
                        this.contatable();
                    }, 500)
    
                },     
                contatable(){  
                    this.$refs.reflsttitulos.selectAllItems()
                    var totsoma = 0
                    for (let i = 0; i < this.$refs.reflsttitulos.selected_items.length; i++) {
                        //var vltit = parseFloat(this.$refs.reflsttitulos.selected_items[i].vltit);
                        var vltit = parseFloat(this.$refs.reflsttitulos.selected_items[i].vlresta);
                        var juros = parseFloat(this.$refs.reflsttitulos.selected_items[i].vljuros);
                        var multa = parseFloat(this.$refs.reflsttitulos.selected_items[i].vlmulta);
                        
                        totsoma = totsoma + vltit + juros + multa
                    }
                    this.vtotalnegociar = totsoma
                    this.mtdliberacalc('vvalordescacres')
                   
                },       
                mtdregistro(){
                    let vself  = this;
                    let loader = vself.$loading.show();
                    let registrocrud = {
                        'id'                : this.vid,
                        'idfilial'          : this.pidfilial,
                        'idcliente'         : this.$refs.reflsttitulos.selected_items[0].idcliente,
                        'obs'               : this.vobservacoes,
                        'idtipocobranca'    : this.vidtipocobranca,
                        'idcobrador'        : this.vidcobrador, 
                        'idvendedor'        : this.vidvendedor,
                        'percdescjuros'     : this.vpercdescjuros  === null ? 0 : this.vpercdescjuros,  //adicionei pois esse valor pode pegar da listagem do banco nulo caso não haja essa informação
                        'valordescjuros'    : this.vvalordescjuros === null ? 0 : this.vvalordescjuros,
                        'percdescmulta'     : this.vpercdescmulta  === null ? 0 : this.vpercdescmulta,
                        'valordescmulta'    : this.vvalordescmulta === null ? 0 : this.vvalordescmulta,
                        'totalnegociar'     : this.vtotalnegociar  === null ? 0 : this.vtotalnegociar,
                        'tpdescacres'       : this.vtpdescacres    === null ? 0 : this.vtpdescacres,
                        'total'             : this.vtotalpagar,
                        'motivo'            : this.vmotivoreneg,
                        'titnegociados'     : this.$refs.reflsttitulos.selected_items,
                        'titnovos'          : this.lsttitulosgp,
                        'qtdparcelas'       : this.vqtdparc,
                        'intervalo'         : this.vIntervalo,
                        'totaldebatual'     : this.tottitlista,
                        'defentrada'        : this.vdefentrada,
                        'vlentrada'         : this.vvalorlentrada,
                        'vlacrescdesc'      : this.vvalordescacres,
                        'perfiljurosmulta'  : parseInt(this.vdefnovoj),
                        'subtrairentrada'   : this.vsubtrairentrada === true ? 1 : 0 
                    };
                    let parametros      = [
                        {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'rotinacrud'},
                        {parametro: 'opcrud',       valor : vself.opcrud},
                        {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                        {parametro: 'straleatoria', valor : vself.sringaleatoria},
                        {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '030Z.035Z.010Z' : parseInt(this.opcrud) === 2 ? '030Z.035Z.020Z' : '030Z.035Z.030Z'},
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadrenegociacao.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if ($.isNumeric(response.data)){
                            vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                            vself.pfiltro       = 0;
                            vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                            vself.pqtd_paginas  = 1;
                            vself.mtdcancelaredicao();
                            vself.mtdcarregarenegociacoes(1);
                        }else{
                            let tpret = response.data.substring(0,1);
                            switch (tpret) {
                                case 'I':
                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                    break;
                                case 'E': default:
                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                    break;
                            }
                        }
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    });
                },
                mtdcalculaselecionados(){
                        this.rtzerarselecionados();
                        for (var i = 0; i < this.$refs.reflsttitulos.selected_items.length; i++) {
                            this.vselecionados    = this.$refs.reflsttitulos.selected_items.length
                            this.vlapagarreneg    = this.vlapagarreneg    + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlresta);
                            //this.vlapagarreneg    = this.vlapagarreneg    + parseFloat(this.$refs.reflsttitulos.selected_items[i].vltit);
                            this.vltotjurosreneg  = this.vltotjurosreneg  + parseFloat(this.$refs.reflsttitulos.selected_items[i].vljuros);
                            this.vltotmultasreneg = this.vltotmultasreneg + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlmulta);
    
                            this.vTotalJurosSel   = this.vTotalJurosSel   + parseFloat(this.$refs.reflsttitulos.selected_items[i].vljuros);
                            this.vTotalMultaSel   = this.vTotalMultaSel   + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlmulta);
                            // this.vTotalGeralSel   = this.vTotalGeralSel   + parseFloat(this.$refs.reflsttitulos.selected_items[i].vltit);
                            this.vTotalGeralSel   = this.vTotalGeralSel   + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlresta);
                            this.vTotalRenegSel   = this.vltotmultasreneg + this.vltotjurosreneg + this.vlapagarreneg
                        }          
                },
                rtzerarselecionados() {
                this.vselecionados        = 0;
                this.vlapagarreneg        = 0;     
                this.vltotjurosreneg      = 0;     
                this.vltotmultasreneg     = 0;     
                this.vTotalGeralSel       = 0;
                this.vTotalMultaSel       = 0;
                this.vTotalJurosSel       = 0;
                },
                mtdformatadatagravar(dtformatar) {
                    let strret = dtformatar.replace(/\D/g, "");
                    return strret.substring(0, 2) + '/' + strret.substring(2, 4) + '/' + strret.substring(4);
                },  
                mtdgerarparcelas(){
                    this.lsttitulosgp = [];
                    var totalpagar = this.vtotalpagar;
                    if(this.vvalorlentrada > totalpagar){
                        this.$toastr.w('O valor da entrada não pode ser maior que o total da divida!', 'Atenção!');
                        $('#edvlentrada').focus();
                        return;
                    }
                    if(this.vsubtrairentrada){
                        totalpagar = this.vtotalpagar - this.vvalorlentrada
                    }
    
                    if(parseInt(this.vdefentrada) != 0){ // gera a parcela de entrada
                        let entradatmp = {  
                            'codtit' 			  : 'ENT-'+this.vqtdparc,
                            'dtventit'			  : util.DataAtual(true),
                            'vltit'				  : this.vvalorlentrada,
                            'idtipocobranca'	  : this.vidtipocobranca,
                            'tipocobranca'        : this.tipocobgp,// 0 - Normal 1 - Cheque
                            'descricaocob'        :  $('#cbtipocobranca').select2('data')[0]['text'],
                            'numerocheque'		  : '',
                            'idbanco'			  : null,
                            'descbanco'			  : '',
                            'agencia'			  : '',
                            'conta'				  : '',
                            'praca'				  : '',
                            'emitente'			  : '',
                            'tpcalcjuros'	      : this.vtpjurosnew,
                            'tpcalcmulta'	      : this.vtpmultanew,
                            'fatjuros'	          : this.vfatorjurosnew,
                            'fatmulta'	          : this.vfatormultanew,
                            'cnpjcpf'			  : '',						
                            'idsituacaocheque'	  : null,
                            'descsituacaocheque'  : '',
                            'idvendedor'          : this.vidvendedor,
                            'idcobrador'          : this.vidcobrador,
                        };
                        this.lsttitulosgp.push(entradatmp);   		
                    }
                    for (let i = 0; i < this.vqtdparc; i++) {
                        let dtventmp = i + 1 === 1 ? this.vdtpriparc : util.somaDias(this.mtdformatadatagravar(this.vdtpriparc), parseFloat(i * this.vIntervalo));
                        let parctmp = {
                            'codtit' 			  : this.mtdformatarzeros(i + 1, 2) + '-'+this.vqtdparc,
                            'dtventit'			  : dtventmp,
                            'vltit'				  : util.arredondaValores(parseFloat(totalpagar) / parseFloat(this.vqtdparc), 2, 'round'),
                            'idtipocobranca'	  : this.vidtipocobranca,
                            'tipocobranca'        : this.tipocobgp,// 0 - Normal 1 - Cheque
                            'numerocheque'		  : '',
                            'descricaocob'        :  $('#cbtipocobranca').select2('data')[0]['text'],
                            'idbanco'			  : null,
                            'descbanco'			  : '',
                            'agencia'			  : '',
                            'conta'				  : '',
                            'praca'				  : '',
                            'emitente'			  : '',
                            'tpcalcjuros'	      : this.vtpjurosnew,
                            'tpcalcmulta'	      : this.vtpmultanew,
                            'fatjuros'	          : this.vfatorjurosnew,
                            'fatmulta'	          : this.vfatormultanew,
                            'cnpjcpf'			  : '',						
                            'idsituacaocheque'	  : null,
                            'descsituacaocheque'  : '',
                            'idvendedor'          : this.vidvendedor,
                            'idcobrador'          : this.vidcobrador,
                        };
                        this.lsttitulosgp.push(parctmp);
                    }
    
                    this.mtdcalculatotaltit();
                },
                mtdalterartitulo(titulo) {
                    if(this.opcrud==3){
                        return
                    }
                    this.tacodtitgp = titulo.codtit;
                    this.tadtventitgp = titulo.dtventit;
                    this.tavltitgp = parseFloat(titulo.vltit);
                    this.taidtipocobrancagp = titulo.idtipocobranca;
                    this.tatipocobrancagp = parseInt(titulo.tipocobranca);
                    this.tadescricaocobgp = titulo.descricaocob;
                    this.tanumerochequegp = titulo.numerocheque;
                    this.taidbancogp = titulo.idbanco;
                    this.tadescbancogp = titulo.descbanco;
                    this.taagenciagp = titulo.agencia;
                    this.tacontagp = titulo.conta;
                    this.tapracagp = titulo.praca;
                    this.taemitentegp = titulo.emitente;
                    this.tacnpjcpfgp = titulo.cnpjcpf;
                    this.taidsituacaochequegp = titulo.idsituacaocheque;
                    this.tadescsituacaochequegp = titulo.descsituacaocheque;
    
                    console.log(this.tacodtitgp)
                    console.log(this.tadtventitgp)
                    console.log(this.tavltitgp)
    
    
                    var deftipocobranca = new Option(this.tadescricaocobgp, this.taidtipocobrancagp, true, true);
                    $('#cbtipocobrancaaltgp').append(deftipocobranca).trigger('change');
    
                    if (this.taidbancogp !== null) {
                        var defbanco = new Option(this.tadescbancogp, this.taidbancogp, true, true);
                        $('#cbbancogp').append(defbanco).trigger('change');
                    } else {
                        $("#cbbancogp").val(null).trigger('change');
                    }
    
                    if (this.taidsituacaochequegp !== null) {
                        var defsituacaoch = new Option(this.tadescsituacaochequegp, this.taidsituacaochequegp, true, true);
                        $('#cbsituacaochequegp').append(defsituacaoch).trigger('change');
                    } else {
                        $("#cbsituacaochequegp").val(null).trigger('change');
                    }
    
                    $('#mdalterartitulogp').modal('show');
                },
                mtdcalculatotaltit(){
                    this.tottitlista = 0
                    for (let i = 0; i < this.lsttitulosgp.length; i++) {
                        this.tottitlista = this.tottitlista + parseFloat(this.lsttitulosgp[i].vltit);
                    }
                },
                mtconfirmaralteracaotitulo() {
                    if (this.tadtventitgp === '') {
                        this.$toastr.w('Data de vencimento deve ser informada!', 'Atenção!');
                        $('#eddtventit').focus();
                        return;
                    }
                    if (parseFloat(this.tavltitgp) <= 0) {
                        this.$toastr.w('Valor do título inválido!', 'Atenção!');
                        $('#edvltit').focus();
                        return;
                    }
                    if (this.taidtipocobrancagp === null) {
                        this.$toastr.w('Tipo de cobrança deve ser informada!', 'Atenção!');
                        $('#cbtipocobrancaaltgp').focus();
                        return;
                    }
                    if (parseInt(this.tatipocobrancagp) === 1) {
                        if (this.tanumerochequegp === '') {
                            this.$toastr.w('Número do cheque deve ser informado!', 'Atenção!');
                            $('#ednumerochequegp').focus();
                            return;
                        }
                        if (this.taidbancogp === null) {
                            this.$toastr.w('Banco deve ser informado!', 'Atenção!');
                            $('#cbbancogp').focus();
                            return;
                        }
                        if (this.taagenciagp === '') {
                            this.$toastr.w('Agência deve ser informada!', 'Atenção!');
                            $('#edagenciagp').focus();
                            return;
                        }
                        if (this.tacontagp === '') {
                            this.$toastr.w('Conta deve ser informada!', 'Atenção!');
                            $('#edcontagp').focus();
                            return;
                        }
                        if (this.tapracagp === '') {
                            this.$toastr.w('Praça deve ser informada!', 'Atenção!');
                            $('#edpracagp').focus();
                            return;
                        }
                        if (this.taemitentegp === '') {
                            this.$toastr.w('Emitente deve ser informado!', 'Atenção!');
                            $('#edemitentegp').focus();
                            return;
                        }
                        if (this.tacnpjcpfgp === '') {
                            this.$toastr.w('CNPJ/CPF deve ser informado!', 'Atenção!');
                            $('#edcnpjcpfgp').focus();
                            return;
                        }
                        if (this.taidsituacaochequegp === null) {
                            this.$toastr.w('Situação do cheque deve ser informada!', 'Atenção!');
                            $('#cbsituacaochequegp').focus();
                            return;
                        }
                    }
                    let indice = util.getArrayIndexForKey(this.lsttitulosgp, 'codtit', this.tacodtitgp);
                    //this.vtotaltitulosgp = this.vtotaltitulosgp - this.lsttitulosgp[indice].vltit;
    
    
                    this.lsttitulosgp[indice].dtventit           = this.tadtventitgp;
                    this.lsttitulosgp[indice].dtventit           = this.tadtventitgp;
                    this.lsttitulosgp[indice].vltit              = this.tavltitgp;
                    this.lsttitulosgp[indice].idtipocobranca     = this.taidtipocobrancagp;
                    this.lsttitulosgp[indice].tipocobranca       = this.tatipocobrancagp;
                    this.lsttitulosgp[indice].descricaocob       = $('#cbtipocobrancaaltgp').select2('data')[0]['text'];
    
                    this.lsttitulosgp[indice].numerocheque       = parseInt(this.tatipocobrancagp) === 1 ? this.tanumerochequegp : '';
                    this.lsttitulosgp[indice].idbanco            = parseInt(this.tatipocobrancagp) === 1 ? this.taidbancogp : null;
                    this.lsttitulosgp[indice].descbanco          = parseInt(this.tatipocobrancagp) === 1 ? $('#cbbancogp').select2('data')[0]['text'] : '';
                    this.lsttitulosgp[indice].agencia            = parseInt(this.tatipocobrancagp) === 1 ? this.taagenciagp : '';
                    this.lsttitulosgp[indice].conta              = parseInt(this.tatipocobrancagp) === 1 ? this.tacontagp : '';
                    this.lsttitulosgp[indice].praca              = parseInt(this.tatipocobrancagp) === 1 ? this.tapracagp : '';
                    this.lsttitulosgp[indice].emitente           = parseInt(this.tatipocobrancagp) === 1 ? this.taemitentegp : '';
                    this.lsttitulosgp[indice].cnpjcpf            = parseInt(this.tatipocobrancagp) === 1 ? this.tacnpjcpfgp : '';
                    this.lsttitulosgp[indice].idsituacaocheque   = parseInt(this.tatipocobrancagp) === 1 ? this.taidsituacaochequegp : null;
                    this.lsttitulosgp[indice].descsituacaocheque = parseInt(this.tatipocobrancagp) === 1 ? $('#cbsituacaochequegp').select2('data')[0]['text'] : '';
    
                    this.mtdcalculatotaltit();
    
                    $('#mdalterartitulogp').modal('hide');
                },
                mtdimprimir(idreneg, situacao){	
                    if (!util.opcaousuario('030Z.035Z.050Z', this.$store.state.perfilusuario)){
                        this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                    }else {		
                        window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirreneg.php?idclientesac='+
                                this.$store.state.filialpadrao.idcliente+
                                '&idreneg='+idreneg+'&idu='+
                                this.$store.state.usuario.id, '_blank');	
                    }         			
                },
                mtdefetivar(reneg) {
                  var idreneg   = reneg.id
                  var idcliente = reneg.idcliente
                  
    
                  let vself = this
                    if (!util.opcaousuario('030Z.035Z.040Z', this.$store.state.perfilusuario)){
                        this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                    }else{
                    
                            $.confirm({
                                title: 'Confirmação!',
                                content: 'Confirma ' + 'efetivação da Negociação' + '?',
                                icon: 'fa fa-question-circle',
                                escapeKey: true,
                                backgroundDismiss: false,
                                escapeKey: 'nao',
                                type: 'dark',
                                typeAnimated: true,
                                buttons: {
                                    sim: {
                                        text: '<u>S</u>im',
                                        keys: ['s', 'S'],
                                        btnClass: 'btn-blue',
                                        action: function () {
                                            $('.btn-blue').prop('disabled', true);
    
                                            let parametros      = [
                                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'op',           valor : 'efetivar'},
                                    {parametro: 'idcliente',    valor : idcliente},
                                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                    {parametro: 'idreneg',      valor : parseInt(idreneg)},
                                    {parametro: 'codop',        valor : '030Z.035Z.040Z'},
                                ];
                                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadrenegociacao.php');
                                retorno.then(function (response) {  
                                    if ($.isNumeric(response.data)){
                                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                                        vself.pfiltroperiodo = 0;
                                        vself.psituacao      = 5;
                                        vself.pid            = idreneg;
                                        vself.pqtd_paginas  = 1;
                                        vself.mtdcancelaredicao();
                                        vself.mtdcarregarenegociacoes(1);
                                    }else{
                                        let tpret = response.data.substring(0,1);
                                        switch (tpret) {
                                            case 'I':
                                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                break;
                                            case 'E': default:
                                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                break;
                                        }
                                    }
                                
                                }).catch(function (response) {
                                    ///retorno mau
                                
                                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                });
                                        },
                                    },
                                    nao: {
                                        text: '<u>N</u>ão',
                                        keys: ['n', 'N'],
                                        action: function () {
                                            
                                        }
                                    }
                                }
                            });
    
                            this.controlesit = 0
                    }
                },
                mtdextornar(reneg) {
                  var idreneg   = reneg.id
                  var idcliente = reneg.idcliente
                  
                  let vself = this
                    if (!util.opcaousuario('030Z.035Z.045Z', this.$store.state.perfilusuario)){
                        this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                    }else{
                    
                            $.confirm({
                                title: 'Confirmação!',
                                content: 'Confirma ' + 'Extorno da renegociação' + '?',
                                icon: 'fa fa-question-circle',
                                escapeKey: true,
                                backgroundDismiss: false,
                                escapeKey: 'nao',
                                type: 'dark',
                                typeAnimated: true,
                                buttons: {
                                    sim: {
                                        text: '<u>S</u>im',
                                        keys: ['s', 'S'],
                                        btnClass: 'btn-blue',
                                        action: function () {
                                            $('.btn-blue').prop('disabled', true);
    
                                            let parametros      = [
                                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'op',           valor : 'extornar'},
                                    {parametro: 'idcliente',    valor : idcliente},
                                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                    {parametro: 'idreneg',      valor : parseInt(idreneg)},
                                    {parametro: 'codop',        valor : '030Z.035Z.045Z'},
                                ];
                                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadrenegociacao.php');
                                retorno.then(function (response) {  
                                    if ($.isNumeric(response.data)){
                                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                                        vself.pfiltroperiodo = 0;
                                        vself.psituacao      = 5;
                                        vself.pid            = idreneg;
                                        vself.pqtd_paginas  = 1;
                                        vself.mtdcancelaredicao();
                                        vself.mtdcarregarenegociacoes(1);
                                    }else{
                                        let tpret = response.data.substring(0,1);
                                        switch (tpret) {
                                            case 'I':
                                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                break;
                                            case 'E': default:
                                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                break;
                                        }
                                    }
                                
                                }).catch(function (response) {
                                    ///retorno mau
                                
                                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                });
                                        },
                                    },
                                    nao: {
                                        text: '<u>N</u>ão',
                                        keys: ['n', 'N'],
                                        action: function () {
                                            
                                        }
                                    }
                                }
                            });
    
                            this.controlesit = 0
                    }
                },
                mtddeform(){
                    setTimeout(() => {
                        $('#edpercdescjuros').focus();
                        this.mtdliberacalc('vpercdescjuros');
                    }, 300);
    
                    
                },
                mtdliberacalc(campo){
                    if(campo=='vvalordescacres'){
                        
                        switch (parseInt(this.vtpdescacres)) {
                            case 0:
                                this.vvalordescacres  = 0;
                                this.vtotalpagar      = this.vtotalnegociar;
                                break;
                            case 1:
                                if(this.vvalordescacres > this.vtotalnegociar){
                                    this.vtotalpagar  = this.vvalordescacres - this.vtotalnegociar;
                                }else{
                                    this.vtotalpagar  = this.vtotalnegociar  - this.vvalordescacres;
                                }
                                break;
                            case 2:
                                this.vtotalpagar      = this.vvalordescacres + this.vtotalnegociar;
                                break;
                        }
                    }
                    if(campo=='vpercdescmulta'){
                        if(this.vpercdescmulta > 100 || this.vpercdescmulta < 0){
                            this.$toastr.i('Informe um valor entre 0 (zero) e 100 (cem) %!', 'Informação!');
                        }else{
                            let rMulta            = 0;                
                            rMulta                = this.vMulta * (1-(this.vpercdescmulta/100));
                            this.vvalordescmulta  = rMulta;
                            this.vtotalnegociar   = this.vvalordescjuros + this.vvalordescmulta + this.vTotalGeralSel;
                            this.vtotalpagar      = this.vtotalnegociar;
                        }
                        if(this.vvalordescmulta > 0){
                            this.addMultaClass    = 'coloratraso'
                        }else{
                            this.addMultaClass    = '';
                        }
                        this.mtdliberacalc('vvalordescacres')    
                    }
                    if(campo=='vpercdescjuros'){
                        if(this.vpercdescjuros > 100 || this.vpercdescjuros < 0){
                            this.$toastr.i('Informe um valor entre 0 (zero) e 100 (cem) %!', 'Informação!');
                        }else{
                            let rJuros            = 0;
                            rJuros                = this.vJuros * (1-(this.vpercdescjuros/100));
                            this.vvalordescjuros  = rJuros;
                            this.vtotalnegociar   = this.vvalordescjuros + this.vvalordescmulta + this.vTotalGeralSel;
                            this.vtotalpagar      = this.vtotalnegociar;
                        }
                        if(this.vvalordescjuros > 0){
                            this.addJurosClass    = 'coloratraso'
                        }else{
                            this.addJurosClass    = '';
                        } 
                        this.mtdliberacalc('vvalordescacres')        
                    } 
             
                    if(campo=='vvalordescmulta'){
                        let nperc = 0
                        if(this.vvalordescmulta===0){ ///para evitar o problema matematico (0/0) no qual não existe valor definido -guga
                            nperc = 0;
                        }else{
                            nperc = (100 * this.vvalordescmulta) / this.vMulta
                        }
                        this.vpercdescmulta   = nperc
                        this.vtotalnegociar   = this.vvalordescjuros + this.vvalordescmulta + this.vTotalGeralSel;
                        this.vtotalpagar      = this.vtotalnegociar;
                        this.mtdliberacalc('vvalordescacres')      
                    }      
                    if(campo=='vvalordescjuros'){
                        let nperc = 0
                        if(this.vvalordescjuros===0){ ///para evitar o mesmo problema matematico descrito acima -guga
                            nperc = 0;
                        }else{
                            nperc = (100 * this.vvalordescjuros) / this.vJuros
                        }
                        this.vpercdescjuros   = nperc
                        this.vtotalnegociar   = this.vvalordescjuros + this.vvalordescmulta + this.vTotalGeralSel;
                        this.vtotalpagar      = this.vtotalnegociar;
                        this.mtdliberacalc('vvalordescacres')        
                    }                      
                   
                    if(this.opcrud==2){
                        this.mtdgerarparcelas();
                    }
    
                    //console.log(this.vpercdescjuros)
                 ////
                },     
                mtdrotinaextorno(){
                    $('#mdextornareneg').modal('show');
                },
                listarrenegcliente(id){
                    var vself       = this;
                    let loader      = vself.$loading.show();
                    let filtro      = 'and r.situacao = 1 and r.idcliente='+id;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 99999999},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadrenegociacao.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.listarenegextorno = response.data;
                    }).catch(function (response) {
                        loader.hide();
                    });
                },
            },
            mounted: function () {
                if (util.verificasessao(this)) {
                    let vself = this;
                    let loader = vself.$loading.show();
                    let parametros = [
                        {parametro: 'op', valor: 'dadosusuario'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                        {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                    ];
                    let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                        if (util.opcaousuario('030Z.035Z', vself.$store.state.perfilusuario)) {
                            $('#pnlista').fadeIn(700);
                            vself.mtdexecutapesquisa();
                            vself.mtdselect2_def();
                        } else {
                            vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                            setTimeout(function(){
                                util.gotoprincipal();
                            },1000);
                        }
                    }).catch(function (response) {
                        loader.hide();
                        console.log(response.message);
                    });
                }
            //    setInterval(() => {
            //      console.log(this.vpercdescjuros)
            //    }, 5000);
            },
            computed:{
                selecionaperiodo(){
                    if(parseInt(this.pfiltroperiodo) === 0){
                        this.hab_desab_periodo = true;
                    }else{
                        this.hab_desab_periodo = false;
                    }
                    if(parseInt(this.opcrud) === 3){
                        this.hab_desab_periodo = true;
                    }else{
                        this.hab_desab_periodo = false;
                    }
                    
                },
                selecionadesconto(){
                    if(parseInt(this.vtpdescacres) === 0){
                        this.hab_desab_desconto = true;
                    }else{
                        this.hab_desab_desconto = false;
                    }
    
                    if(parseInt(this.opcrud) === 3){
                        this.hab_desab_desconto = true;
                    }else{
                        this.hab_desab_desconto = false;
                    }
                },
                selecionaentrada(){
                    if(parseInt(this.vdefentrada) === 0){
                        this.hab_desab_entrada = true;
                    }else{
                        this.hab_desab_entrada = false;
                    }
                    if(parseInt(this.opcrud) === 3){
                        this.hab_desab_entrada = true;
                    }else{
                        this.hab_desab_entrada = false;
                    }
                },
                selecionanovosjm(){
                    if(parseInt(this.vdefnovoj) === 0){
                        this.hab_desab_novo_juros_multa = false;
                    }
                    if(parseInt(this.vdefnovoj) === 1){
                        this.hab_desab_novo_juros_multa = true;
                    }
                    if((parseInt(this.opcrud) === 3)&&(parseInt(this.vdefnovoj)== 0)){
                        this.hab_desab_novo_juros_multa = false;
                    }
                   
                },
                validou() {
                    return this.vidtipocobranca === null || this.vidcobrador === null || this.vidvendedor === null || this.vtotalpagar === 0;
                },
                validoucrud(){
                    return this.vidtipocobranca === null || this.vidcobrador === null || this.vidvendedor === null || this.vtotalpagar === 0 || this.lsttitulosgp.length === 0;
                },
            },
            watch:{
                vsubtrairentrada(){
                    if(this.opcrud===2){
                        this.mtdgerarparcelas()
                    }
                },
                pagina_atual(val){
                    this.mtdcarregarenegociacoes(val);
                },
                vTotalJurosSel() {
                    this.vvalordescjuros   = this.vTotalJurosSel;
                    if(this.vvalordescjuros > 0){
                        this.addJurosClass = 'coloratraso'
                    }else{
                        this.addJurosClass = '';
                    }                
                },
                vTotalMultaSel() {
                    this.vvalordescmulta   = this.vTotalMultaSel;
                    if(this.vvalordescmulta > 0){
                        this.addMultaClass = 'coloratraso'
                    }else{
                        this.addMultaClass = '';
                    }
                }, 
                vtpdescacres(){
                    switch (parseInt(this.vtpdescacres)) {
                        case 0:
                            this.vvalordescacres  = 0;
                            this.vtotalpagar      = this.vtotalnegociar;
                            break;
                        case 1:
                            if(this.vvalordescacres > this.vtotalnegociar){
                                this.vtotalpagar  = this.vvalordescacres - this.vtotalnegociar;
                            }else{
                                this.vtotalpagar  = this.vtotalnegociar  - this.vvalordescacres;
                            }
                            break;
                        case 2:
                            this.vtotalpagar      = this.vvalordescacres + this.vtotalnegociar;
                            break;
                    }
                },
    
            }
        }
    </script>
    <style>
        .def-col-cod{
            width: 80px !important;
        }
    
    
    
        .def-col-opcoes-reneg{
            width: 60px !important;
        }
        #btclonarperfilusuario{
            cursor: pointer;
            font-weight: bold;
            font-size: 18px;
            position: relative;
            float: right;
            top: 5px;
            transition: .35s;
        }
        #btmarcartodosopusuario{
            font-weight: bold;
            font-size: 18px;
            padding-right: 10px;
            cursor: pointer;
            position: relative;
            float: right;
            top: 5px;
            transition: .35s;
        }
        #btmarcartodosopusuario:hover{
            color: #666666;
            transition: .35s;
        }
    
        #btmarcartodfiliais{
            font-weight: bold;
            font-size: 18px;
            padding-right: 10px;
            cursor: pointer;
            position: relative;
            float: right;
            top: 5px;
            transition: .35s;
        }
        #btmarcartodfiliais:hover{
            color: #666666;
            transition: .35s;
        }
        #btclonarperfilusuario:hover{
            color: #666666;
            transition: .35s;
        }
        .bdg-aberto{
            background-color: darkorange !important;
        }
        .bdg-efetivado{
            background-color: darkgreen !important;
        }
        .bdg-extornado{
            background-color: rgb(100, 25, 0) !important;
        }
    
        .btn-extornar{
            background-color: rgb(149, 6, 6) !important;
        }
    </style>